export const UPDATE_USER_TOKEN = "UPDATE_USER_TOKEN";
export const UPDATE_REFRESH_TOKEN = "UPDATE_REFRESH_TOKEN";
export const UPDATE_DRAWER_OPEN = "UPDATE_DRAWER_OPEN";
export const UPDATE_RESTAURANT_DATA = "UPDATE_RESTAURANT_DATA";
export const UPDATE_USER_ID = "UPDATE_USER_ID";
export const UPDATE_FEATURES_LIST = "UPDATE_FEATURES_LIST";
export const LOG_OUT = "LOG_OUT";
export const UPDATE_RESTAURANT_CATEGORY_LIST =
  "UPDATE_RESTAURANT_CATEGORY_LIST";
export const UPDATE_RESTAURANT_COURSE_LIST = "UPDATE_RESTAURANT_COURSE_LIST";
export const UPDATE_RESTAURANT_MENU_LIST = "UPDATE_RESTAURANT_MENU_LIST";
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const UPDATE_USER_DETAIL = 'UPDATE_USER_DETAIL';
export const UPDATE_USER_ROLES_LIST = 'UPDATE_USER_ROLES_LIST';
export const UPDATE_SELECTED_MENU_CATEGORY = 'UPDATE_SELECTED_MENU_CATEGORY';
